import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 노드 구성정보 조회
   * @author Song(thdgusrkd)
   * @param  {Boolean} 트리 - 노드 구성정보 조회
   * @return {[type]}        [description]
   */
  getNodeConfigInfoForObjtype(params) {
    return axios.post(`${baseUrl}/virtual/performance/get-node-config-info-for-objtype.do`, params);
  },
  /**
   * 그룹 구성정보 조회
   * @author Song(thdgusrkd)
   * @param  {Boolean} 트리 - 그룹 구성정보 조회
   * @return {[type]}        [description]
   */
  getGroupConfigInfoForObjtype(params) {
    return axios.post(`${baseUrl}/virtual/performance/get-group-config-info-for-objtype.do`, params);
  },
  /**
   * 노드 구성정보 업데이트
   * @author Song(thdgusrkd)
   * @param  {Boolean} 트리 - 노드 구성정보 업데이트
   * @return {[type]}        [description]
   */
  updateVmsObjConfig(params) {
    return axios.post(`${baseUrl}/virtual/performance/update-vms-obj-config.do`, params);
  },
  /**
   * 그룹 공통 구성정보 조회
   * @author Song(thdgusrkd)
   * @param  {Boolean} 트리 - 노드 구성정보 업데이트
   * @return {[type]}        [description]
   */
  getGroupConfigInfoForCommonObjtype(params) {
    return axios.post(`${baseUrl}/virtual/performance/get-group-config-info-for-common-objtype.do`, params);
  },
  /**
   * 그룹 공통 구성정보 엑셀 출력 - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author Song(thdgusrkd) -> NaJY
   * @param  {Boolean}
   * @return {[type]}        [description]
   */
  exportVmsConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/virtual/performance/export-vms-config-info-device-list.do`, params);
  },
  /**
   * 그룹 구성정보 엑셀 출력
   * @author Song(thdgusrkd)
   * @param  {Boolean}
   * @return {[type]}        [description]
   */
  exportVmsConfigInfoTargetDeviceList(params) {
    return axios.post(`${baseUrl}/virtual/performance/export-vms-config-info-target-device-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/virtual/performance/config.js